module.exports = __webpack_public_path__ + "img/popup-bottom-battery-2.ff085633.svg";